export const Constants = {
  roles: {
    conops: "conops",
  }
}
